import type { BackupVault } from '@/data/vaults/backupVault';

import ButtonWithIcon from '../buttons/buttonWithIcon';

const generateKmsKeyUrl = (kmsArn?: string) => {
  const kmsRegion = kmsArn?.split('arn:aws:kms:')[1]?.split(':')[0];
  const baseUrl = `${kmsRegion}.console.aws.amazon.com/kms/home?region=${kmsRegion}#/kms/keys`;
  const kmsId = kmsArn?.split(':key/')[1];
  return kmsId ? `${baseUrl}/${kmsId}/editPolicy` : baseUrl;
};

export const KmsEditKeyPolicyButton = ({
  backupVault,
}: {
  backupVault: BackupVault;
}) => {
  return (
    <ButtonWithIcon
      variant='contained'
      disabled={!backupVault.vaultAttributes.aws?.encryptionKey}
      text='Edit Key Policy in AWS'
      icon='material-symbols-open-in-new'
      iconPosition='right'
      onClick={() =>
        window.open(
          generateKmsKeyUrl(backupVault.vaultAttributes.aws?.encryptionKey),
          '_blank'
        )
      }
    />
  );
};
